import {
  Alert,
  Box,
  Button,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { CRMContext } from './CRM'
import AmbuNetLogo from '../assets/images/ambunetLogo.png'
import API from '../services/API'

const Login = ({ setUser }) => {
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [MFA, setMFA] = useState('')
  const [loginFailed, setLoginFailed] = useState(false)

  const handleLogIn = (e) => {
    e.preventDefault()
    API.post('/admincrm/login', {
      username: userName,
      password,
      mfa: MFA,
    }).then((res) => {
      if (res.status === 200) {
        setUser(res.data)
      } else {
        setLoginFailed(true)
      }
    })
  }

  return (
    <Box height="100vh">
      <Box
        display="flex"
        justifyContent="center"
        position="relative"
        padding={4}
        gap={2}
      >
        <Box
          sx={{
            backgroundImage: `url(${AmbuNetLogo})`,
            backgroundRepeat: 'repeat',
            backgroundSize: '100px',
            minHeight: '100vh',
            minWidth: '100%',
            position: 'absolute',
            top: 0,
            zIndex: -1,
            opacity: 0.5,
          }}
        />
        <Box
          marginTop={5}
          padding={5}
          component={Paper}
          width="30rem"
          maxWidth="100%"
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            padding={5}
            maxWidth="90vw"
            gap={2}
            component="form"
            onSubmit={handleLogIn}
          >
            <Typography variant="title2">Log In</Typography>
            <TextField
              label="UserName"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              required
            />
            <TextField
              label="Password"
              InputLabelProps={{ shrink: true }}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              required
            />
            <TextField
              InputLabelProps={{ shrink: true }}
              label="MFA"
              value={MFA}
              onChange={(e) => setMFA(e.target.value)}
              fullWidth
              required
            />
            {loginFailed && (
              <Alert severity="error" variant="filled">
                Login Failed
              </Alert>
            )}
            <Button type="submit" color="success" variant="contained" fullWidth>
              Submit
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  )
}

export default Login
